export class Registration {
	id: number;
	oneRosterApiUrl: string;
	oneRosterApiVersion: string;
	oauthVersion: string;
	oauthClientId: string;
	oauthClientSecret: string;
	syncEnabled: boolean;
	syncInitialized: boolean;
	syncStatus: string;
	lastSyncError: string;
	lastSyncErrorAt: Date;
	lastSyncedAt: Date;
	syncCrunJob: string;
	organizationCount: number;
	studentCount: number;
	studentContactCount: number;
	createdAt: Date;
	updatedAt: Date;
	oauthTokenEndpoint: string;

	constructor() {
		this.id = 0;
		this.oneRosterApiUrl = '';
		this.oneRosterApiVersion = '';
		this.oauthVersion = '';
		this.oauthClientId = '';
		this.oauthClientSecret = '';
		this.syncEnabled = true;
		this.syncInitialized = false;
		this.syncStatus = '';
		this.lastSyncError = '';
		this.lastSyncErrorAt = new Date();
		this.lastSyncedAt = new Date();
		this.organizationCount = 0;
		this.studentCount = 0;
		this.studentContactCount = 0;
		this.syncCrunJob = '0 22 * * *';
		this.createdAt = new Date();
		this.oauthTokenEndpoint = '';
	}
}
